<script>
    import { notifier } from '@beyonk/svelte-notifications'
    import Tags from './Tags.svelte';
    import QuestionTypes from '../lib/QuestionTypes';
    import Loader from './Loader.svelte';
    import {replace} from 'svelte-spa-router'

    import {sortBy} from "lodash-es";

    import {db} from '../Database.svelte';

    import LibraryControl from './AssessmentType/LibraryControl.svelte';

    import  TagMappingModal, {showMappingModal} from './TagMappingModal.svelte';
    import ReferencesField from '../Forms/CustomFields/ReferencesField.svelte';

    import TinyMCEField from '../Forms/CustomFields/tinymceField.svelte';
    import QuestionLibrary from '../Models/QuestionLibraryModel';

    export let assessment_type, category_id, subcategory_id, control_id;

    let control;

    function saveControl() {
        assessment_type.model.saveControl(control).then(() => notifier.success("Control Saved"))
    }

    async function setControl(control_id) {
        try {
            control = await assessment_type.model.getControl(category_id, subcategory_id, control_id);
        } catch {
            notifier.danger("Invalid Control");
            replace(`/assessmentTypes/${assessment_type.id}/`)
            return
        }

        if (!control.recommendation_map) {
            control.recommendation_map = {};
        }

        if (!control.tag_mapping) {
            control.tag_mapping = {};
        }
    }

    function getMap(tag_map) {
        return new Promise((resolve, reject) => {
            let map_id;
            if (tag_map.id) {
                map_id = tag_map.id;
            } else {
                map_id = tag_map;
            }

            db.get(map_id).then((doc) => {
                if (doc.type == "positiveControl") {
                    resolve({
                        type: "Positive Control",
                        text: doc.title
                    });
                } else if (doc.type == "serviceRecommendation") {
                    resolve({
                        type: "Service Recommendation",
                        text: doc.title
                    });
                } else if (doc.type == "stockRecommendation") {
                    resolve({
                        type: "Finding",
                        text: `${doc.finding}\n---\n${doc.recommendation}`
                    })
                } else  {
                    // find related section
                    let section_name;
                    for (let section of assessment_type.report_sections) {
                        if (section.section_id == tag_map.section_id) {
                            section_name = section.section_name
                            break
                        }
                    }

                    if (!section_name) {
                        reject("Section not Found");
                    }

                    resolve({
                        type: section_name,
                        text: doc.name
                    })
                }
            }).catch(reject)
        });
    }

    function addMapping(tag) {
        showMappingModal().then((result) => {
            if (!control.tag_mapping[tag.tag_id]) {
                control.tag_mapping[tag.tag_id] = []
            }
            control.tag_mapping[tag.tag_id] = [...control.tag_mapping[tag.tag_id], result];
        }).catch(() => null)
    }

    function removeMapping(tag, tag_map) {
        control.tag_mapping[tag.tag_id] = control.tag_mapping[tag.tag_id].filter(t => t != tag_map);
    }

    function addAnswerMapping(answer_value) {
        showMappingModal().then(result => {
            if (!control.recommendation_map[answer_value]) {
                control.recommendation_map[answer_value] = [result];
            } else {
                control.recommendation_map[answer_value] = [...control.recommendation_map[answer_value], result];
            }
        });
    }

    function removeAnswerMapping(answer_value, answer_map) {
        control.recommendation_map[answer_value] = control.recommendation_map[answer_value].filter(map => map != answer_map)
    }

    $: setControl(control_id);
</script>

<Loader loading={!control}>
    {#if !control.library_id}
        <div class="box">
            <div class="buttons is-right save">
                <button class="button is-right is-success" on:click={saveControl}>
                    Save
                </button>
            </div>
            <div class="columns">
                <div class="field column is-narrow">
                    <label class="label" for="input_control_number">Control Number</label>
                    <div class="control">
                        <input type="text" class="input title is-4" bind:value={control.control_number} id="input_control_number">
                    </div>
                </div>
                <div class="field column">
                    <label class="label" for="input_control_name">Control Title</label>
                    <div class="control">
                        <input type="text" class="input title is-4" bind:value={control.name} id="input_control_name">
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column flex">
                    <h3 class="title is-4">Control Text</h3>
                    <textarea class="textarea is-size-4 flex-grow" bind:value={control.text}></textarea>
                </div>
                <div class="column">
                    <h3 class="title is-4">Control Level</h3>
                    <div class="select is-fullwidth">
                        <select bind:value={control.level}>
                            <option value="1">Level 1</option>
                            <option value="2">Level 2</option>
                            <option value="3">Level 3</option>
                            <option value="4">Level 4</option>
                            <option value="5">Level 5</option>
                        </select>
                    </div>
                    <h3 class="title is-4">Answer Type</h3>
                    <div class="select is-fullwidth">
                        <select bind:value={control.question_type}>
                            <option value="implementation_status_new">Implementation Status</option>
                            <option value="yes_no_new">Yes/No</option>

                            <option value="implementation_status">Implementation Status (old)</option>
                            <option value="yes_no">Yes/No (old)</option>
                            <option value="free_text">Free Text</option>
                        </select>
                    </div>
                    <h3 class="title is-4">References</h3>
                    <ReferencesField bind:value={control.references} />

                    <h3 class="title is-4">Topic Tags</h3>
                    <div class="field is-grouped- is-grouped-multiline">
                        <div class="control">
                            <Tags bind:tags={control.topic_tags} addKeys={[9,13]} autoComplete={Object.keys(assessment_type.topic_tags)} />
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns flex-grow">
                <div class="column flex-column">
                    <h3 class="title is-4">Supplemental Guidance</h3>
                    <TinyMCEField bind:value={control.guidance} classNames="textarea is-size-5 flex-grow" />
                    <!-- <textarea class="textarea is-size-5 flex-grow" bind:value={control.guidance} bind:this={guidance_textarea} id="guidance_textarea"></textarea>-->
                </div>
                <div class="column">
                    <h3 class="title is-4">Finding Mapping</h3>
                    <table class="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Answer</th>
                                <th>Mappings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#if control.question_type != "free_text"}
                                {#each sortBy(Object.values(QuestionTypes[control.question_type].buttons), ["order"]) as btn (btn.label)}
                                    <tr>
                                        <td>{btn.label}</td>
                                        <td>
                                            <table class="table is-fullwidth">
                                                <thead>
                                                    <tr>
                                                        <th>Mapping Type</th>
                                                        <th>Mapping Value</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan=3>
                                                            <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping(btn.value)}>Add Mapping</button>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                                <tbody>
                                                    {#each control.recommendation_map[btn.value] || [] as answer_map}
                                                        <tr>
                                                            {#await getMap(answer_map)}
                                                            <td colspan="3">
                                                                Loading...
                                                            </td>
                                                            {:then mapping}
                                                                <td>
                                                                    {mapping.type}
                                                                </td>
                                                                <td class="prewrap">
                                                                    {mapping.text}
                                                                </td>
                                                                <td>
                                                                    <button class="button is-danger" on:click={() => removeAnswerMapping(btn.value, answer_map)}>Delete</button>
                                                                </td>
                                                            {:catch e}
                                                                <td colspan="2">Mapping No Longer Exists ({e})</td>
                                                                <td><button class="button is-danger" on:click={() => removeAnswerMapping(btn.value, answer_map)}>Delete</button></td>
                                                            {/await}
                                                        </tr>
                                                    {/each}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                {/each}
                            {:else}
                                    <tr>
                                        <tr>
                                            <td>Any</td>
                                            <td>
                                                <table class="table is-fullwidth">
                                                    <thead>
                                                        <tr>
                                                            <th>Mapping Type</th>
                                                            <th>Mapping Value</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan=3>
                                                                <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping("text")}>Add Mapping</button>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                    <tbody>
                                                        {#each control.recommendation_map["text"] || [] as answer_map}
                                                            <tr>
                                                                {#await getMap(answer_map)}
                                                                <td colspan="3">
                                                                    Loading...
                                                                </td>
                                                                {:then mapping}
                                                                    <td>
                                                                        {mapping.type}
                                                                    </td>
                                                                    <td class="prewrap">{mapping.text}</td>
                                                                    <td>
                                                                        <button class="button is-danger" on:click={() => removeAnswerMapping("text", answer_map)}>Delete</button>
                                                                    </td>
                                                                {:catch}
                                                                    <td colspan="2">Mapping No Longer Exists</td>
                                                                    <td><button class="button is-danger" on:click={() => removeAnswerMapping("text", answer_map)}>Delete</button></td>
                                                                {/await}
                                                            </tr>
                                                        {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                            {/if}
                        </tbody>
                    </table>
                    <h3 class="title is-4">Tag Mapping</h3>
                    <table class="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Tag</th>
                                <th>Mappings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each assessment_type.question_tags as tag (tag.tag_id)}
                            <tr>
                                <td class="has-background-{tag.color_class}">
                                    {tag.name}
                                </td>
                                <td>
                                    <table class="table is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Mapping Type</th>
                                                <th>Mapping Value</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                                <td colspan=3>
                                                    <button class="button is-pulled-right is-info" on:click={() => addMapping(tag)}>Add Mapping</button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                        <tbody>
                                            {#each control.tag_mapping[tag.tag_id] || [] as tag_map}
                                                <tr>
                                                    {#await getMap(tag_map)}
                                                    <td colspan="3">
                                                        Loading...
                                                    </td>
                                                    {:then mapping}
                                                        <td>
                                                            {mapping.type}
                                                        </td>
                                                        <td class="prewrap">{mapping.text}</td>
                                                        <td>
                                                            <button class="button is-danger" on:click={() => removeMapping(tag, tag_map)}>Delete</button>
                                                        </td>
                                                    {:catch}
                                                        <td colspan="2">Mapping No Longer Exists</td>
                                                        <td><button class="button is-danger" on:click={() => removeMapping(tag, tag_map)}>Delete</button></td>
                                                    {/await}
                                                </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {/each}
                        </tbody>
                    </table>

                </div>


            </div>

            <div class="save buttons is-right">
                <button class="button is-success" on:click={saveControl}>
                    Save
                </button>
            </div>
        </div>
    {:else}
        <div class="box">
            {#await QuestionLibrary.getStore(control.library_id)}
                Loading...
            {:then ctrl}
                <LibraryControl assessment_control={control} control={ctrl} {assessment_type} />
            {/await}
        </div>
    {/if}
</Loader>

<TagMappingModal {assessment_type} />

<style>
    .save {
        padding-top: .5em;
    }

    .box {
        display: flex;
        flex-direction: column;
    }

    .flex {
        display: flex;
        flex-direction: column;
        padding: 0;
    }

    .flex-center {
        display: flex;
        align-items: center;
    }

    .recommendationModal {
        width: calc(100vw - 50px);
    }

    .modal-card-foot {
        justify-content: flex-end;
    }

    .guidance {
        border: 1px solid black;
        padding: 10px;
    }
</style>